import { render, staticRenderFns } from "./ListPrenatalPerObstetric.vue?vue&type=template&id=50f0de6c&scoped=true"
import script from "./ListPrenatalPerObstetric.vue?vue&type=script&lang=js"
export * from "./ListPrenatalPerObstetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0de6c",
  null
  
)

export default component.exports